"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  MonitorAntenna: ['monitor-antenna', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M.312,11.691a.72.72,0,0,0,.7.393h5.6a.694.694,0,0,0,.56-1.184L6.339,9.886a.25.25,0,0,1,.222-.407,4.323,4.323,0,0,0,.51.031,5.477,5.477,0,0,0,.765-.054,5.3,5.3,0,0,0,3.511-2.09.49.49,0,0,0-.1-.688l-3-2.242a.253.253,0,0,1-.1-.18.249.249,0,0,1,.068-.193l2.2-2.3A.983.983,0,1,0,9,.405L6.593,2.92a.249.249,0,0,1-.33.027L3.493.874a.492.492,0,0,0-.689.1,5.314,5.314,0,0,0,.138,6.568.249.249,0,0,1,0,.316L.451,10.9A.72.72,0,0,0,.312,11.691Z', 'M18.219,10.566a.983.983,0,0,0,.983-.984V6.676a3.937,3.937,0,0,0-3.933-3.933H13.052a.983.983,0,0,0,0,1.966h2.217a1.969,1.969,0,0,1,1.967,1.967V9.582A.983.983,0,0,0,18.219,10.566Z', 'M3.47,14.253a.983.983,0,0,0-.983.983v2.256A3.937,3.937,0,0,0,6.42,21.425H9.365a.984.984,0,0,0,0-1.967H6.42a1.969,1.969,0,0,1-1.967-1.966V15.236A.983.983,0,0,0,3.47,14.253Z', 'M11.951,18.489v.682a1.466,1.466,0,0,0,.477,1.079,1.955,1.955,0,0,0,1.49.7h2.7a.249.249,0,0,1,.25.25v.483a.25.25,0,0,1-.25.25H15.392a.983.983,0,0,0,0,1.966h4.917a.983.983,0,0,0,0-1.966H19.084a.25.25,0,0,1-.25-.25V21.2a.249.249,0,0,1,.25-.25h2.7a1.954,1.954,0,0,0,1.489-.7,1.466,1.466,0,0,0,.477-1.079v-5.6a1.969,1.969,0,0,0-1.966-1.967H13.918a1.969,1.969,0,0,0-1.967,1.967Zm9.583-4.916a.25.25,0,0,1,.25.25v3.925a.25.25,0,0,1-.25.25H14.168a.249.249,0,0,1-.25-.25V13.823a.249.249,0,0,1,.25-.25Z']],
  MonitorTransferFile: ['monitor-transfer-file', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M20.5,4a.5.5,0,0,1-.5-.5V.25A.25.25,0,0,0,19.75,0H16.5a.5.5,0,0,0-.5.5v9a.5.5,0,0,0,.5.5h7a.5.5,0,0,0,.5-.5V4.25A.25.25,0,0,0,23.75,4Z', 'M21,2.75a.25.25,0,0,0,.25.25H23.1a.25.25,0,0,0,.177-.427L21.427.719A.25.25,0,0,0,21,.9Z', 'M14.5,4a1,1,0,0,0-1-1A6,6,0,0,0,7.747,7.32a.251.251,0,0,1-.24.18H6.5a1,1,0,0,0-.707,1.707l2,2a1,1,0,0,0,1.416,0l2-2A1,1,0,0,0,10.5,7.5h-.31a.249.249,0,0,1-.221-.367A4,4,0,0,1,13.5,5,1,1,0,0,0,14.5,4Z', 'M4.045,8.933A.976.976,0,0,0,3.5,8.75H2a2,2,0,0,0-2,2V19a2,2,0,0,0,2,2H7.75a.25.25,0,0,1,.25.25v.5a.25.25,0,0,1-.25.25H5a1,1,0,0,0,0,2h8a1,1,0,0,0,0-2H10.25a.25.25,0,0,1-.25-.25v-.5a.25.25,0,0,1,.25-.25H16a2,2,0,0,0,2-2V12.75a1,1,0,0,0-2,0v4.5a.25.25,0,0,1-.25.25H2.25A.25.25,0,0,1,2,17.25V11a.25.25,0,0,1,.25-.25H3.5a.987.987,0,0,0,.968-.841A.953.953,0,0,0,4.5,9.75.983.983,0,0,0,4.045,8.933Z']],
  Connector: ['connector', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M0.000 15.750 L4.000 15.750 L4.000 20.250 L0.000 20.250 Z', 'M20.000 15.750 L24.000 15.750 L24.000 20.250 L20.000 20.250 Z', 'M18.5,15.75a1,1,0,0,0-1-1H15.25A.25.25,0,0,1,15,14.5V12.25a1,1,0,0,0-1-1H10a1,1,0,0,0-1,1V14.5a.25.25,0,0,1-.25.25H6.5a1,1,0,0,0-1,1v4.5a1,1,0,0,0,1,1h11a1,1,0,0,0,1-1Z', 'M10.000 2.750 L14.000 2.750 L14.000 9.750 L10.000 9.750 Z']],
  Connector1: ['connector-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M19,10a1,1,0,0,0-1-1H15.25A.25.25,0,0,1,15,8.75V6a1,1,0,0,0-1-1H10A1,1,0,0,0,9,6V8.75A.25.25,0,0,1,8.75,9H6a1,1,0,0,0-1,1v4a1,1,0,0,0,1,1H8.75a.25.25,0,0,1,.25.25V18a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V15.25a.25.25,0,0,1,.25-.25H18a1,1,0,0,0,1-1Z', 'M0.000 9.750 L3.500 9.750 L3.500 14.250 L0.000 14.250 Z', 'M20.500 9.750 L24.000 9.750 L24.000 14.250 L20.500 14.250 Z', 'M9.750 0.000 L14.250 0.000 L14.250 3.500 L9.750 3.500 Z', 'M9.750 20.500 L14.250 20.500 L14.250 24.000 L9.750 24.000 Z']],
  Monitor: ['monitor', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M17.25,20.708h-2.7a.251.251,0,0,1-.233-.158,2.481,2.481,0,0,0-4.632,0,.251.251,0,0,1-.233.158H6.75a.75.75,0,0,0,0,1.5h2.7a.251.251,0,0,1,.233.159,2.481,2.481,0,0,0,4.632,0,.251.251,0,0,1,.233-.159h2.7a.75.75,0,0,0,0-1.5ZM12,22.458a1,1,0,1,1,1-1A1,1,0,0,1,12,22.458Z', 'M2,21.458a.75.75,0,0,0-.75-.75H.75a.75.75,0,0,0,0,1.5h.5A.75.75,0,0,0,2,21.458Z', 'M3.75,20.708a.75.75,0,0,0,0,1.5h.5a.75.75,0,0,0,0-1.5Z', 'M19.75,20.708a.75.75,0,0,0,0,1.5h.5a.75.75,0,0,0,0-1.5Z', 'M23.25,20.708h-.5a.75.75,0,0,0,0,1.5h.5a.75.75,0,0,0,0-1.5Z', 'M20,14.541a2,2,0,0,0,2-2V2.041a2,2,0,0,0-2-2H4a2,2,0,0,0-2,2v10.5a2,2,0,0,0,2,2h6.75a.25.25,0,0,1,.25.25v1a.25.25,0,0,1-.25.25h-5a1,1,0,0,0,0,2h12.5a1,1,0,0,0,0-2h-5a.25.25,0,0,1-.25-.25v-1a.25.25,0,0,1,.25-.25Zm-.25-12.5a.25.25,0,0,1,.25.25v8.5a.25.25,0,0,1-.25.25H4.25a.25.25,0,0,1-.25-.25v-8.5a.25.25,0,0,1,.25-.25Z']],
  Laptop1: ['laptop-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M20.5,12a1,1,0,0,0,1-1V3a3,3,0,0,0-3-3H5.5a3,3,0,0,0-3,3v8a1,1,0,0,0,2,0V3a1,1,0,0,1,1-1h13a1,1,0,0,1,1,1v8A1,1,0,0,0,20.5,12Z', 'M11,21.75a.25.25,0,0,1-.25.25H1a1,1,0,0,0,0,2H23a1,1,0,0,0,0-2H13.25a.25.25,0,0,1-.25-.25V21.5a1,1,0,0,0-1-1h0a1,1,0,0,0-1,1Z', 'M17.26,19a7.076,7.076,0,0,0,6.714-4.842A.5.5,0,0,0,23.5,13.5H16a.5.5,0,0,0-.5.5c0,.708-1.5,1.5-3.5,1.5S8.5,14.708,8.5,14a.5.5,0,0,0-.5-.5H.5a.5.5,0,0,0-.474.658A7.076,7.076,0,0,0,6.74,19Z']],
  MonitorTransferFolder: ['monitor-transfer-folder', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M9.625,7.375h-.7a3.994,3.994,0,0,1,1.628-1.9.65.65,0,0,0,.325-.55h0a1.119,1.119,0,0,0-1.794-.885A6.021,6.021,0,0,0,6.822,7.375h-1.2a1,1,0,0,0-.707,1.707l2,2a1,1,0,0,0,1.416,0l2-2a1,1,0,0,0-.707-1.707Z', 'M22.875,1.625h-4.25a.25.25,0,0,1-.25-.25v-.25a1,1,0,0,0-1-1h-3.5a1,1,0,0,0-1,1v7a1,1,0,0,0,1,1h9a1,1,0,0,0,1-1v-5.5A1,1,0,0,0,22.875,1.625Z', 'M16.481,11.125a.986.986,0,0,0-.356.75v5.25a.25.25,0,0,1-.25.25H2.375a.25.25,0,0,1-.25-.25v-6.25a.25.25,0,0,1,.25-.25h.25a.987.987,0,0,0,.968-.841.953.953,0,0,0,.032-.159.983.983,0,0,0-.455-.817.976.976,0,0,0-.545-.183h-.5a2,2,0,0,0-2,2v8.25a2,2,0,0,0,2,2h5.75a.25.25,0,0,1,.25.25v.5a.25.25,0,0,1-.25.25H5.125a1,1,0,0,0,0,2h8a1,1,0,0,0,0-2h-2.75a.25.25,0,0,1-.25-.25v-.5a.25.25,0,0,1,.25-.25h5.75a2,2,0,0,0,2-2v-7a.987.987,0,0,0-1.644-.75Z']],
  MonitorLock: ['monitor-lock', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M17.25,20.708h-2.7a.251.251,0,0,1-.233-.158,2.481,2.481,0,0,0-4.632,0,.251.251,0,0,1-.233.158H6.75a.75.75,0,0,0,0,1.5h2.7a.251.251,0,0,1,.233.159,2.481,2.481,0,0,0,4.632,0,.251.251,0,0,1,.233-.159h2.7a.75.75,0,0,0,0-1.5ZM12,22.458a1,1,0,1,1,1-1A1,1,0,0,1,12,22.458Z', 'M1.25,20.708H.75a.75.75,0,0,0,0,1.5h.5a.75.75,0,0,0,0-1.5Z', 'M4.25,20.708h-.5a.75.75,0,0,0,0,1.5h.5a.75.75,0,0,0,0-1.5Z', 'M20.25,20.708h-.5a.75.75,0,0,0,0,1.5h.5a.75.75,0,0,0,0-1.5Z', 'M23.25,20.708h-.5a.75.75,0,0,0,0,1.5h.5a.75.75,0,0,0,0-1.5Z', 'M22,2.041a2,2,0,0,0-2-2H17.5a1,1,0,0,0,0,2h2.25a.25.25,0,0,1,.25.25v8.5a.25.25,0,0,1-.25.25H4.25a.25.25,0,0,1-.25-.25v-8.5a.25.25,0,0,1,.25-.25H7a1,1,0,1,0,0-2H4a2,2,0,0,0-2,2v10.5a2,2,0,0,0,2,2h6.75a.25.25,0,0,1,.25.25v1a.25.25,0,0,1-.25.25h-5a1,1,0,0,0,0,2h12.5a1,1,0,0,0,0-2h-5a.25.25,0,0,1-.25-.25v-1a.25.25,0,0,1,.25-.25H20a2,2,0,0,0,2-2Z', 'M8.5,8.041a1.5,1.5,0,0,0,1.5,1.5h4a1.5,1.5,0,0,0,1.5-1.5v-3a1.491,1.491,0,0,0-.643-1.223.249.249,0,0,1-.107-.205V3.041a2.75,2.75,0,0,0-5.5,0v.572a.249.249,0,0,1-.107.205A1.491,1.491,0,0,0,8.5,5.041ZM13,6.561a1,1,0,1,1-1-1A1,1,0,0,1,13,6.561Zm-1-4.77a1.252,1.252,0,0,1,1.25,1.25v.25a.25.25,0,0,1-.25.25H11a.25.25,0,0,1-.25-.25v-.25A1.252,1.252,0,0,1,12,1.791Z']],
  MonitorTeam: ['monitor-team', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M6.462,8.558A.5.5,0,0,0,6,8.25H4a.5.5,0,0,0-.5.5v2a.5.5,0,0,0,.309.462A.512.512,0,0,0,4,11.25a.5.5,0,0,0,.354-.147l.292-.293a.252.252,0,0,1,.354,0l2.72,2.72a.75.75,0,1,0,1.06-1.061L6.061,9.75a.25.25,0,0,1,0-.354L6.354,9.1A.5.5,0,0,0,6.462,8.558Z', 'M.5,6a.5.5,0,0,0,.5.5H6A.5.5,0,0,0,6.5,6,2.86,2.86,0,0,0,5.216,3.48a.255.255,0,0,1-.111-.162.251.251,0,0,1,.04-.192A1.971,1.971,0,0,0,5.5,2a2,2,0,0,0-4,0,1.971,1.971,0,0,0,.355,1.126.251.251,0,0,1,.04.192.255.255,0,0,1-.111.162A2.86,2.86,0,0,0,.5,6Z', 'M23.5,6a2.86,2.86,0,0,0-1.284-2.52.255.255,0,0,1-.111-.162.251.251,0,0,1,.04-.192A1.971,1.971,0,0,0,22.5,2a2,2,0,0,0-4,0,1.971,1.971,0,0,0,.355,1.126.251.251,0,0,1,.04.192.255.255,0,0,1-.111.162A2.86,2.86,0,0,0,17.5,6a.5.5,0,0,0,.5.5h5A.5.5,0,0,0,23.5,6Z', 'M9,6a.5.5,0,0,0,.5.5h5A.5.5,0,0,0,15,6a2.86,2.86,0,0,0-1.284-2.52.255.255,0,0,1-.111-.162.251.251,0,0,1,.04-.192A1.971,1.971,0,0,0,14,2a2,2,0,0,0-4,0,1.971,1.971,0,0,0,.355,1.126.251.251,0,0,1,.04.192.255.255,0,0,1-.111.162A2.86,2.86,0,0,0,9,6Z', 'M15.22,13.53a.748.748,0,0,0,1.06,0L19,10.81a.252.252,0,0,1,.354,0l.292.293A.5.5,0,0,0,20,11.25a.512.512,0,0,0,.191-.038.5.5,0,0,0,.309-.462v-2a.5.5,0,0,0-.5-.5H18a.5.5,0,0,0-.354.853l.293.293a.25.25,0,0,1,0,.354L15.22,12.469A.75.75,0,0,0,15.22,13.53Z', 'M12,13.75a.75.75,0,0,0,.75-.75V10.248A.251.251,0,0,1,13,10l.246,0h0a.5.5,0,0,0,.384-.821l-1.25-1.5A.5.5,0,0,0,12,7.5h0a.5.5,0,0,0-.382.177l-1.25,1.485a.5.5,0,0,0,.379.822l.254,0a.249.249,0,0,1,.249.25V13A.75.75,0,0,0,12,13.75Z', 'M19,21a2,2,0,0,0,2-2V13.25a1,1,0,0,0-2,0v4.5a.25.25,0,0,1-.25.25H5.25A.25.25,0,0,1,5,17.75v-4.5a1,1,0,0,0-2,0V19a2,2,0,0,0,2,2h5.75a.25.25,0,0,1,.25.25v.5a.25.25,0,0,1-.25.25H9a1,1,0,0,0,0,2h6a1,1,0,0,0,0-2H13.25a.25.25,0,0,1-.25-.25v-.5a.25.25,0,0,1,.25-.25Z']],
  MonitorTransfer: ['monitor-transfer', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M4.25,11.963a.75.75,0,0,0,0-1.5h-1a.75.75,0,0,0,0,1.5Z', 'M11.25,5.755a.75.75,0,0,0,.75-.75V1.755A1.751,1.751,0,0,0,10.25.005H1.75A1.751,1.751,0,0,0,0,1.755V7.713a1.75,1.75,0,0,0,1.75,1.75h2.5A.75.75,0,0,0,5,8.713V7.505a.5.5,0,0,0-.5-.5H1.75a.25.25,0,0,1-.25-.25v-5a.251.251,0,0,1,.25-.25h8.5a.251.251,0,0,1,.25.25v3.25A.75.75,0,0,0,11.25,5.755Z', 'M24,9.505a2,2,0,0,0-2-2H8.5a2,2,0,0,0-2,2v9.458a2,2,0,0,0,2,2H14a.25.25,0,0,1,.25.25v.531a.25.25,0,0,1-.25.25H11.25a1,1,0,0,0,0,2h8a1,1,0,0,0,0-2H16.5a.25.25,0,0,1-.25-.25v-.531a.25.25,0,0,1,.25-.25H22a2,2,0,0,0,2-2Zm-2.25,0a.25.25,0,0,1,.25.25v7.458a.25.25,0,0,1-.25.25h-13a.25.25,0,0,1-.25-.25V9.755a.25.25,0,0,1,.25-.25Z']],
  MonitorExchangeArrow1: ['monitor-exchange-arrow-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.25,0H16.78a.738.738,0,0,0-.738.717V.739a.738.738,0,0,0,.739.761h5.47a.251.251,0,0,1,.25.25v5.5a.25.25,0,0,1-.25.25H15.535l-.267.267a2.5,2.5,0,0,1-1.149.655A.8.8,0,0,0,13.5,9.2h0a.8.8,0,0,0,.8.8H16.52a.25.25,0,0,1,.25.25v1a.25.25,0,0,1-.25.25H15A.75.75,0,0,0,15,13h5.25a.75.75,0,0,0,0-1.5H18.52a.249.249,0,0,1-.25-.25v-1a.249.249,0,0,1,.25-.25h3.73A1.751,1.751,0,0,0,24,8.25V1.75A1.75,1.75,0,0,0,22.25,0Z', 'M7.793,11.207a1,1,0,0,0,1.414,0l2-2A1,1,0,0,0,10.5,7.5h-.31a.249.249,0,0,1-.214-.121.253.253,0,0,1-.007-.247,4.015,4.015,0,0,1,2.2-1.888.251.251,0,0,1,.334.236V6a1,1,0,0,0,1.707.707l2-2a1,1,0,0,0,0-1.414l-2-2A1,1,0,0,0,12.5,2v.883a.249.249,0,0,1-.2.244A6.011,6.011,0,0,0,7.747,7.32a.25.25,0,0,1-.24.18H6.5a1,1,0,0,0-.707,1.707Z', 'M0,19a2,2,0,0,0,2,2H7.75a.25.25,0,0,1,.25.25v.5a.25.25,0,0,1-.25.25H5a1,1,0,0,0,0,2h8a1,1,0,0,0,0-2H10.25a.25.25,0,0,1-.25-.25v-.5a.25.25,0,0,1,.25-.25H16a2,2,0,0,0,2-2V15.5a1,1,0,0,0-2,0v1.75a.25.25,0,0,1-.25.25H2.25A.25.25,0,0,1,2,17.25V11a.25.25,0,0,1,.25-.25H3.5a.987.987,0,0,0,.968-.841A.953.953,0,0,0,4.5,9.75a.983.983,0,0,0-.455-.817A.976.976,0,0,0,3.5,8.75H2a2,2,0,0,0-2,2Z']],
  MonitorNetwork: ['monitor-network', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M1,15v3.5a2,2,0,0,0,2,2H4.916a.25.25,0,0,1,.25.25v.5a.25.25,0,0,1-.25.25H4a1,1,0,0,0,0,2H8.5a1,1,0,0,0,0-2H7.416a.249.249,0,0,1-.25-.25v-.5a.249.249,0,0,1,.25-.25H9a2,2,0,0,0,2-2V15a2,2,0,0,0-2-2H3A2,2,0,0,0,1,15Zm8,3.25a.247.247,0,0,1-.073.176.25.25,0,0,1-.177.074H3.25A.25.25,0,0,1,3,18.25v-3A.25.25,0,0,1,3.25,15h5.5a.25.25,0,0,1,.25.25Z', 'M7,2.5V6A2,2,0,0,0,9,8h1.916a.25.25,0,0,1,.25.25v.5a.25.25,0,0,1-.25.25H10a1,1,0,0,0,0,2h4.5a1,1,0,0,0,0-2H13.416a.249.249,0,0,1-.25-.25v-.5a.249.249,0,0,1,.25-.25H15a2,2,0,0,0,2-2V2.5a2,2,0,0,0-2-2H9A2,2,0,0,0,7,2.5Zm8,3.25a.247.247,0,0,1-.073.176A.25.25,0,0,1,14.751,6H9.25A.25.25,0,0,1,9,5.75v-3a.25.25,0,0,1,.25-.25h5.5a.25.25,0,0,1,.25.25Z', 'M21,20.5a2,2,0,0,0,2-2V15a2,2,0,0,0-2-2H15a2,2,0,0,0-2,2v3.5a2,2,0,0,0,2,2h1.916a.25.25,0,0,1,.25.25v.5a.25.25,0,0,1-.25.25H16a1,1,0,0,0,0,2h4.5a1,1,0,0,0,0-2H19.416a.249.249,0,0,1-.25-.25v-.5a.249.249,0,0,1,.25-.25Zm-6-5.25a.25.25,0,0,1,.25-.25h5.5a.25.25,0,0,1,.25.25v3a.247.247,0,0,1-.073.176.25.25,0,0,1-.177.074h-5.5a.25.25,0,0,1-.25-.25Z']],
  MonitorTransfer1: ['monitor-transfer_1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M24,1.75A1.75,1.75,0,0,0,22.25,0h-9.5A1.75,1.75,0,0,0,11,1.75V2a.75.75,0,0,0,1.5,0V1.75a.25.25,0,0,1,.25-.25h9.5a.251.251,0,0,1,.25.25v5.5a.25.25,0,0,1-.25.25H13.5A.5.5,0,0,0,13,8V9.5a.5.5,0,0,0,.5.5h3.02a.25.25,0,0,1,.25.25v1a.25.25,0,0,1-.25.25H15A.75.75,0,0,0,15,13h5.25a.75.75,0,0,0,0-1.5H18.52a.249.249,0,0,1-.25-.25v-1a.249.249,0,0,1,.25-.25h3.73A1.751,1.751,0,0,0,24,8.25Z', 'M11.207,9.707A1,1,0,0,0,10.5,8h-.31a.249.249,0,0,1-.221-.367A4,4,0,0,1,13.5,5.5a1,1,0,0,0,0-2A6,6,0,0,0,7.747,7.82a.251.251,0,0,1-.24.18H6.5a1,1,0,0,0-.707,1.707l2,2a1,1,0,0,0,1.416,0Z', 'M4.045,8.933A.976.976,0,0,0,3.5,8.75H2a2,2,0,0,0-2,2V19a2,2,0,0,0,2,2H7.75a.25.25,0,0,1,.25.25v.5a.25.25,0,0,1-.25.25H5a1,1,0,0,0,0,2h8a1,1,0,0,0,0-2H10.25a.25.25,0,0,1-.25-.25v-.5a.25.25,0,0,1,.25-.25H16a2,2,0,0,0,2-2V15.5a1,1,0,0,0-2,0v1.75a.25.25,0,0,1-.25.25H2.25A.25.25,0,0,1,2,17.25V11a.25.25,0,0,1,.25-.25H3.5a.987.987,0,0,0,.968-.841A.953.953,0,0,0,4.5,9.75.983.983,0,0,0,4.045,8.933Z']],
  NetworkArrowSync: ['network-arrow-sync', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M4.952,12A7.048,7.048,0,1,0,12,4.952,7.056,7.056,0,0,0,4.952,12ZM12,17.168A5.169,5.169,0,0,1,12,6.831c.128,0,.254,0,.38.015a.25.25,0,0,1,.222.18,2.832,2.832,0,0,1,.089.51.253.253,0,0,1-.064.191.249.249,0,0,1-.185.082c-.192,0-.4-.014-.522-.022-.3-.018-.338-.016-.5-.016a2.467,2.467,0,0,0-.334,4.911.25.25,0,0,1,.216.248v.85c0,1.306.706,2.22,1.706,2.22,2,0,2.225-1.738,2.225-2.738,0-.877.012-1.409.011-1.762a4.259,4.259,0,0,0-.02-.5,4.5,4.5,0,0,0-.3-.988A.25.25,0,0,1,15,9.727l.868-.734a.251.251,0,0,1,.366.048A5.159,5.159,0,0,1,12,17.168Z', 'M3.236,19.438a.25.25,0,0,1,0,.323l-.449.533a.7.7,0,0,0,.439,1.152l2.87.409a.915.915,0,0,0,.342.074c.032,0,.063-.008.1-.011l.205.029a.855.855,0,0,0,.1.007.7.7,0,0,0,.67-.921L6.42,17.657a.7.7,0,0,0-1.21-.238l-.413.49A.255.255,0,0,1,4.6,18a.252.252,0,0,1-.193-.1,9.618,9.618,0,0,1,7.6-15.534,9.8,9.8,0,0,1,2.037.215A.939.939,0,1,0,14.435.745,11.522,11.522,0,0,0,.493,12,11.425,11.425,0,0,0,3.236,19.438Z', 'M20.764,4.561a.25.25,0,0,1,0-.323l.449-.533a.7.7,0,0,0-.439-1.151l-2.915-.416a.917.917,0,0,0-.346-.05l-.251-.035a.7.7,0,0,0-.77.914L17.58,6.343a.707.707,0,0,0,.535.475.7.7,0,0,0,.136.013.705.705,0,0,0,.539-.25l.413-.49a.249.249,0,0,1,.388.008A9.616,9.616,0,0,1,12,21.632a9.732,9.732,0,0,1-2.037-.215.94.94,0,1,0-.393,1.838A11.522,11.522,0,0,0,23.507,12,11.426,11.426,0,0,0,20.764,4.561Z']],
  RouterSignal1: ['router-signal-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21,13.872H17.25a.25.25,0,0,1-.25-.25V9.872a1.5,1.5,0,0,0-3,0v3.75a.25.25,0,0,1-.25.25H3a3,3,0,0,0-3,3v2a3,3,0,0,0,2.769,2.991A.251.251,0,0,1,3,22.112v.51a1.5,1.5,0,0,0,3,0v-.5a.25.25,0,0,1,.25-.25h11.5a.25.25,0,0,1,.25.25v.5a1.5,1.5,0,0,0,3,0v-.509a.248.248,0,0,1,.231-.249A3,3,0,0,0,24,18.872v-2A3,3,0,0,0,21,13.872ZM8.081,16.7a1.125,1.125,0,1,1-1.125,1.125A1.125,1.125,0,0,1,8.081,16.7Zm-3.875,2.33a1.175,1.175,0,0,1-.718-.262A1.184,1.184,0,0,1,3,17.828a1.206,1.206,0,1,1,2.411,0,1.176,1.176,0,0,1-.252.7A1.185,1.185,0,0,1,4.206,19.033Z', 'M11.257,5.63a1,1,0,1,0,1.414,1.414,4.1,4.1,0,0,1,5.658,0A1,1,0,1,0,19.743,5.63a6,6,0,0,0-8.486,0Z', 'M9.843,4.215a8.01,8.01,0,0,1,11.314,0A1,1,0,0,0,22.571,2.8a10.013,10.013,0,0,0-14.142,0A1,1,0,1,0,9.843,4.215Z']],
  RouterSignalDouble: ['router-signal-double', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M24,17a3,3,0,0,0-3-3h-.25a.25.25,0,0,1-.25-.25V9.5a1.5,1.5,0,1,0-3,0v4.25a.25.25,0,0,1-.25.25H6.75a.25.25,0,0,1-.25-.25V9.5a1.5,1.5,0,0,0-3,0v4.25a.25.25,0,0,1-.25.25H3a3,3,0,0,0-3,3v2a3,3,0,0,0,2.769,2.991A.249.249,0,0,1,3,22.241v.26a1.5,1.5,0,0,0,3,0v-.25A.25.25,0,0,1,6.25,22h11.5a.25.25,0,0,1,.25.25v.25a1.5,1.5,0,1,0,3,0v-.26a.249.249,0,0,1,.231-.249A3,3,0,0,0,24,19ZM8.08,19.081a1.125,1.125,0,1,1,1.125-1.125A1.125,1.125,0,0,1,8.08,19.081Zm-3.874.081a1.181,1.181,0,0,1-.718-.262A1.185,1.185,0,0,1,3,17.956a1.206,1.206,0,0,1,2.411,0,1.176,1.176,0,0,1-.252.7A1.183,1.183,0,0,1,4.206,19.162ZM20,19H16a1,1,0,0,1,0-2h4a.99.99,0,0,1,.471,1.866A.97.97,0,0,1,20,19Z', 'M3.087,4.46a1,1,0,0,0,.838,1.816,3,3,0,0,1,2.427-.039,1,1,0,0,0,.78-1.842A5.007,5.007,0,0,0,3.087,4.46Z', 'M.148,2.7a1,1,0,0,0,1.375.329,6.993,6.993,0,0,1,7.083-.138,1,1,0,1,0,.979-1.744,9,9,0,0,0-9.109.177A1,1,0,0,0,.148,2.7Z', 'M16.991,4.46a1,1,0,0,0,.838,1.816,3.005,3.005,0,0,1,2.428-.039,1,1,0,0,0,.779-1.842A5.007,5.007,0,0,0,16.991,4.46Z', 'M23.872,2.51a1,1,0,0,0-.382-1.361,9,9,0,0,0-9.109.177,1,1,0,0,0,1.046,1.705,6.993,6.993,0,0,1,7.083-.138A1,1,0,0,0,23.872,2.51Z']],
  Laptop: ['laptop', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M24,22.958a1,1,0,0,0-1-1H12.75a.25.25,0,0,1-.25-.25v-1.75a.25.25,0,0,1,.25-.25H22a1.75,1.75,0,0,0,1.512-2.632l-2.333-4a1.75,1.75,0,0,0-1.512-.869H5.5a.5.5,0,0,1-.5-.5V2.958a.5.5,0,0,1,.5-.5h6a1,1,0,0,0,0-2H5a2,2,0,0,0-2,2v11C3,13.494.97,17.076.97,17.076a1.749,1.749,0,0,0,1.51,2.632h7.77a.25.25,0,0,1,.25.25v1.75a.25.25,0,0,1-.25.25H1a1,1,0,0,0,0,2H23A1,1,0,0,0,24,22.958Zm-13.5-5.75a.75.75,0,1,1,0-1.5h3a.75.75,0,0,1,0,1.5Z', 'M13.333,3.541a2.25,2.25,0,1,0,0,4.5,2.218,2.218,0,0,0,1.38-.485.252.252,0,0,1,.248-.036l1.836.735a.25.25,0,0,1,.155.2,2.256,2.256,0,1,0,.834-2.09.252.252,0,0,1-.248.036l-1.494-.6a.25.25,0,0,1-.036-.446L17.829,4.26a.25.25,0,0,1,.251,0,2.224,2.224,0,0,0,1.087.285,2.25,2.25,0,1,0-2.24-2.22.249.249,0,0,1-.121.22L14.671,3.823a.25.25,0,0,1-.251,0A2.224,2.224,0,0,0,13.333,3.541Z']],
  MonitorExchangeArrow: ['monitor-exchange-arrow', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M10.25,11.5h-8a2,2,0,0,0-2,2v5.693a1.49,1.49,0,0,0,.486,1.1A1.987,1.987,0,0,0,2.25,21H5a.25.25,0,0,1,.25.25v.5A.25.25,0,0,1,5,22H3.75a1,1,0,0,0,0,2h5a1,1,0,0,0,0-2H7.5a.25.25,0,0,1-.25-.25v-.5A.25.25,0,0,1,7.5,21h2.75a1.987,1.987,0,0,0,1.514-.709,1.49,1.49,0,0,0,.486-1.1V13.5A2,2,0,0,0,10.25,11.5Zm-.25,2a.25.25,0,0,1,.25.25v4A.25.25,0,0,1,10,18H2.5a.25.25,0,0,1-.25-.25v-4a.25.25,0,0,1,.25-.25Z', 'M23.75,2a2,2,0,0,0-2-2h-8a2,2,0,0,0-2,2V7.693a1.49,1.49,0,0,0,.486,1.1A1.987,1.987,0,0,0,13.75,9.5H16.5a.25.25,0,0,1,.25.25v.5a.25.25,0,0,1-.25.25H15.25a1,1,0,0,0,0,2h5a1,1,0,0,0,0-2H19a.25.25,0,0,1-.25-.25v-.5A.25.25,0,0,1,19,9.5h2.75a1.987,1.987,0,0,0,1.514-.709,1.49,1.49,0,0,0,.486-1.1ZM21.5,2a.25.25,0,0,1,.25.25v4a.25.25,0,0,1-.25.25H14a.25.25,0,0,1-.25-.25v-4A.25.25,0,0,1,14,2Z', 'M7.126,5.39a.5.5,0,0,0,.224.053.5.5,0,0,0,.3-.1l2-1.5a.5.5,0,0,0,0-.8l-2-1.5a.5.5,0,0,0-.8.4v.25a.25.25,0,0,1-.25.25H4.85a3,3,0,0,0-3,3v1.5a.25.25,0,0,1-.25.25H1.35a.5.5,0,0,0-.4.8l1.5,2a.5.5,0,0,0,.8,0l1.5-2a.5.5,0,0,0-.4-.8H4.1a.25.25,0,0,1-.25-.25v-1.5a1,1,0,0,1,1-1H6.6a.25.25,0,0,1,.25.25v.25A.5.5,0,0,0,7.126,5.39Z']],
  LaptopLock: ['laptop-lock', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M20.5,12a1,1,0,0,0,1-1V3a3,3,0,0,0-3-3H5.5a3,3,0,0,0-3,3v8a1,1,0,0,0,2,0V3a1,1,0,0,1,1-1h13a1,1,0,0,1,1,1v8A1,1,0,0,0,20.5,12Z', 'M12,20.5a1,1,0,0,0-1,1v.25a.25.25,0,0,1-.25.25H1a1,1,0,0,0,0,2H23a1,1,0,0,0,0-2H13.25a.25.25,0,0,1-.25-.25V21.5a1,1,0,0,0-1-1Z', 'M17.26,19a7.076,7.076,0,0,0,6.714-4.842A.5.5,0,0,0,23.5,13.5H16a.5.5,0,0,0-.5.5c0,.708-1.5,1.5-3.5,1.5S8.5,14.708,8.5,14a.5.5,0,0,0-.5-.5H.5a.5.5,0,0,0-.474.658A7.076,7.076,0,0,0,6.74,19Z', 'M12,3.5A3.254,3.254,0,0,0,8.75,6.75v.322a.251.251,0,0,1-.107.205A1.489,1.489,0,0,0,8,8.5v2A1.5,1.5,0,0,0,9.5,12h5A1.5,1.5,0,0,0,16,10.5v-2a1.489,1.489,0,0,0-.643-1.223.251.251,0,0,1-.107-.205V6.75A3.254,3.254,0,0,0,12,3.5Zm1,6a1,1,0,1,1-1-1A1,1,0,0,1,13,9.5ZM12,5a1.752,1.752,0,0,1,1.75,1.75A.25.25,0,0,1,13.5,7h-3a.25.25,0,0,1-.25-.25A1.752,1.752,0,0,1,12,5Z']],
  PhoneMonitorExchange: ['phone-monitor-exchange', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.8,11.221a1.753,1.753,0,0,0-1.75-1.75h-6a1.753,1.753,0,0,0-1.75,1.75v11a1.752,1.752,0,0,0,1.75,1.75h6a1.752,1.752,0,0,0,1.75-1.75Zm-2,9a.249.249,0,0,1-.25.25h-5a.249.249,0,0,1-.25-.25v-8.5a.251.251,0,0,1,.25-.25h5a.251.251,0,0,1,.25.25Z', 'M12.2,2.028a2,2,0,0,0-2-2h-8a2,2,0,0,0-2,2V7.721a1.493,1.493,0,0,0,.485,1.1A1.99,1.99,0,0,0,2.2,9.528H4.95a.25.25,0,0,1,.25.25v.5a.25.25,0,0,1-.25.25H3.7a1,1,0,0,0,0,2h5a1,1,0,0,0,0-2H7.45a.25.25,0,0,1-.25-.25v-.5a.25.25,0,0,1,.25-.25H10.2a1.987,1.987,0,0,0,1.514-.709,1.49,1.49,0,0,0,.486-1.1V2.028Zm-2.25,0a.25.25,0,0,1,.25.25v4a.25.25,0,0,1-.25.25H2.45a.25.25,0,0,1-.25-.25v-4a.25.25,0,0,1,.25-.25Z', 'M20.3,8.179a1,1,0,0,0,1-1V6.971a4,4,0,0,0-4-4H15.045a1,1,0,1,0,0,2H17.3a2,2,0,0,1,2,2v.208A1,1,0,0,0,20.3,8.179Z', 'M12.05,19.971H8.3a2,2,0,0,1-2-2V15.177a1,1,0,0,0-2,0v2.794a4,4,0,0,0,4,4h3.75a1,1,0,0,0,0-2Z']],
  RouterSignal: ['router-signal', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21,13.585H13.75a.25.25,0,0,1-.25-.25V6.585a1.5,1.5,0,0,0-3,0v6.75a.25.25,0,0,1-.25.25H3a3,3,0,0,0-3,3v2a3,3,0,0,0,2.769,2.991A.25.25,0,0,1,3,21.825v.26a1.5,1.5,0,0,0,3,0v-.25a.249.249,0,0,1,.25-.25h11.5a.249.249,0,0,1,.25.25v.25a1.5,1.5,0,0,0,3,0v-.26a.25.25,0,0,1,.231-.249A3,3,0,0,0,24,18.585v-2A3,3,0,0,0,21,13.585ZM5.159,18.243A1.2,1.2,0,0,1,3,17.54a1.206,1.206,0,0,1,2.411,0A1.176,1.176,0,0,1,5.159,18.243Zm2.922.422A1.125,1.125,0,1,1,9.206,17.54,1.125,1.125,0,0,1,8.081,18.665Z', 'M6.967,3.017A1,1,0,0,0,5.6,3.386a6.419,6.419,0,0,0-.119,6.2,1,1,0,0,0,1.772-.93,4.424,4.424,0,0,1,.081-4.278A1,1,0,0,0,6.967,3.017Z', 'M3.355.546A1,1,0,0,0,1.991.92a11.547,11.547,0,0,0-.186,10.989,1,1,0,1,0,1.77-.93A9.529,9.529,0,0,1,3.729,1.91,1,1,0,0,0,3.355.546Z', 'M17.166,10.01a.989.989,0,0,0,.463.115,1,1,0,0,0,.887-.535,6.421,6.421,0,0,0-.119-6.2,1,1,0,0,0-1.734,1,4.426,4.426,0,0,1,.081,4.278A1,1,0,0,0,17.166,10.01Z', 'M20.425,10.98a1,1,0,1,0,1.77.93A11.549,11.549,0,0,0,22.009.92a1,1,0,1,0-1.738.99A9.534,9.534,0,0,1,20.425,10.98Z']],
  PhoneAntenna: ['phone-antenna', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M10.14.261A.748.748,0,0,0,9.08.285L6.65,2.822a.25.25,0,0,1-.33.027L3.3.588a.5.5,0,0,0-.7.1A5.4,5.4,0,0,0,2.74,7.371a.25.25,0,0,1,0,.317l-2.535,3.1a.73.73,0,0,0-.142.8.733.733,0,0,0,.712.4H6.466a.706.706,0,0,0,.57-1.2l-.85-1.039a.25.25,0,0,1,.223-.407,4.4,4.4,0,0,0,.528.033,5.548,5.548,0,0,0,.779-.056,5.393,5.393,0,0,0,3.57-2.125.5.5,0,0,0-.1-.7L7.932,4.056a.25.25,0,0,1-.03-.373l2.261-2.361A.75.75,0,0,0,10.14.261Z', 'M18.275,8.2a1,1,0,0,0,1-1V6.489a4,4,0,0,0-4-4H13.02a1,1,0,0,0,0,2h2.255a2,2,0,0,1,2,2V7.2A1,1,0,0,0,18.275,8.2Z', 'M4.275,17.489V14.945a1,1,0,0,0-2,0v2.544a4,4,0,0,0,4,4H12.25a1,1,0,1,0,0-2H6.275A2,2,0,0,1,4.275,17.489Z', 'M24,11.2a1.752,1.752,0,0,0-1.75-1.75h-6A1.752,1.752,0,0,0,14.5,11.2v11a1.752,1.752,0,0,0,1.75,1.75h6A1.752,1.752,0,0,0,24,22.2Zm-2,9a.25.25,0,0,1-.25.25h-5a.25.25,0,0,1-.25-.25V11.7a.251.251,0,0,1,.25-.25h5a.25.25,0,0,1,.25.25Z']],
  RouterSignalTech: ['router-signal-tech', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M18.714,19.015a.25.25,0,0,1-.214-.247V16a1,1,0,0,0-2,0v2.75a.25.25,0,0,1-.25.25H7.75a.25.25,0,0,1-.25-.25V16a1,1,0,0,0-2,0v2.768a.25.25,0,0,1-.214.247A1.5,1.5,0,0,0,4,20.5v2A1.5,1.5,0,0,0,5.5,24h13A1.5,1.5,0,0,0,20,22.5v-2A1.5,1.5,0,0,0,18.714,19.015ZM12,21.5a1,1,0,1,1-1-1A1,1,0,0,1,12,21.5Zm-4.5-1a1,1,0,1,1-1,1A1,1,0,0,1,7.5,20.5Z', 'M7,9a.5.5,0,0,0,.447-.724l-.191-.382A.272.272,0,0,1,7.5,7.5a2,2,0,0,0,2-2v-3a2,2,0,0,0-2-2h-5a2,2,0,0,0-2,2v3a2,2,0,0,0,2,2,.272.272,0,0,1,.244.394l-.191.382A.5.5,0,0,0,3,9ZM2.5,2.75a.25.25,0,0,1,.25-.25h4.5a.25.25,0,0,1,.25.25v2.5a.25.25,0,0,1-.25.25H2.75a.25.25,0,0,1-.25-.25Z', 'M7.562,12.55a1,1,0,0,0,1.388.276,5.583,5.583,0,0,1,6.1,0,1,1,0,1,0,1.111-1.664,7.618,7.618,0,0,0-8.322,0A1,1,0,0,0,7.562,12.55Z', 'M8.948,14.168a1,1,0,0,0,1.112,1.664,3.549,3.549,0,0,1,3.881,0,1,1,0,0,0,1.11-1.664A5.588,5.588,0,0,0,8.948,14.168Z', 'M23.5,2a2,2,0,0,0-2-2h-3a2,2,0,0,0-2,2V8.5a2,2,0,0,0,2,2h3a2,2,0,0,0,2-2V2ZM21.25,2a.25.25,0,0,1,.25.25v4.5a.25.25,0,0,1-.25.25h-2.5a.25.25,0,0,1-.25-.25V2.25A.25.25,0,0,1,18.75,2Z']],
  SignalLoading: ['signal-loading', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.707,11.293l-5-5a1,1,0,0,0-1.414,1.414l4.116,4.116a.25.25,0,0,1,0,.354l-4.116,4.116a1,1,0,1,0,1.414,1.414l5-5A1,1,0,0,0,23.707,11.293Z', 'M2.591,12.177a.25.25,0,0,1,0-.354L6.707,7.707A1,1,0,0,0,5.293,6.293l-5,5a1,1,0,0,0,0,1.414l5,5a1,1,0,1,0,1.414-1.414Z', 'M10.500 12.000 A1.500 1.500 0 1 0 13.500 12.000 A1.500 1.500 0 1 0 10.500 12.000 Z', 'M15.000 12.000 A1.500 1.500 0 1 0 18.000 12.000 A1.500 1.500 0 1 0 15.000 12.000 Z', 'M6.000 12.000 A1.500 1.500 0 1 0 9.000 12.000 A1.500 1.500 0 1 0 6.000 12.000 Z']],
  Network1: ['network-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.864,22.023H13.245a.25.25,0,0,1-.25-.25v-.815a.25.25,0,0,1,.22-.248A10.392,10.392,0,0,0,12.009,0c-.152,0-.3,0-.448.01A10.128,10.128,0,0,0,1.61,10.186a10.53,10.53,0,0,0,9.184,10.526.251.251,0,0,1,.221.248v.813a.25.25,0,0,1-.25.25H1.136a.99.99,0,0,0,0,1.98H22.864a.99.99,0,0,0,0-1.98Zm-7.687-3.849a.25.25,0,0,1-.314-.353,19.08,19.08,0,0,0,1.015-2.1.25.25,0,0,1,.232-.156h1.969a.25.25,0,0,1,.187.416A8.475,8.475,0,0,1,15.177,18.174ZM9.652,13.582a.25.25,0,0,1-.24-.182,13.151,13.151,0,0,1-.371-1.733.254.254,0,0,1,.058-.2.251.251,0,0,1,.19-.086H14.73a.248.248,0,0,1,.189.086.251.251,0,0,1,.059.2,13.314,13.314,0,0,1-.371,1.733.251.251,0,0,1-.241.182Zm10.189-.16a.25.25,0,0,1-.233.16H16.913a.248.248,0,0,1-.2-.1.251.251,0,0,1-.048-.213,15.039,15.039,0,0,0,.3-1.673.249.249,0,0,1,.248-.22h2.847a.249.249,0,0,1,.247.289A8.365,8.365,0,0,1,19.841,13.422Zm.482-4.309a.258.258,0,0,1-.058.2.252.252,0,0,1-.19.087H17.292a.25.25,0,0,1-.25-.236,13.248,13.248,0,0,0-.421-2.694.251.251,0,0,1,.242-.314h2.268a.25.25,0,0,1,.218.128A8.3,8.3,0,0,1,20.323,9.113ZM17.135,3.728a.251.251,0,0,1-.153.449H15.921a.249.249,0,0,1-.225-.141c-.152-.312-.313-.622-.487-.927a.25.25,0,0,1,.322-.351A8.415,8.415,0,0,1,17.135,3.728ZM11.812,2.276a.26.26,0,0,1,.4,0,13.657,13.657,0,0,1,1.1,1.519.25.25,0,0,1-.212.382H10.924a.25.25,0,0,1-.212-.382A13.657,13.657,0,0,1,11.812,2.276Zm2.461,3.881a.249.249,0,0,1,.237.17,11.208,11.208,0,0,1,.562,2.806.248.248,0,0,1-.066.188.251.251,0,0,1-.183.08H9.2a.25.25,0,0,1-.249-.268,11.208,11.208,0,0,1,.562-2.806.249.249,0,0,1,.237-.17ZM8.543,2.675a.25.25,0,0,1,.315.355c-.193.331-.37.667-.535,1.006a.25.25,0,0,1-.225.141H6.9a.25.25,0,0,1-.153-.448A8.221,8.221,0,0,1,8.543,2.675ZM4.564,6.288a.251.251,0,0,1,.22-.131H7.156a.25.25,0,0,1,.242.314,13.237,13.237,0,0,0-.421,2.694.25.25,0,0,1-.249.236H3.907a.25.25,0,0,1-.248-.282A8.1,8.1,0,0,1,4.564,6.288Zm-.125,7.294a.249.249,0,0,1-.232-.159,8.678,8.678,0,0,1-.482-1.751.25.25,0,0,1,.247-.291H6.8a.25.25,0,0,1,.248.22,15.267,15.267,0,0,0,.3,1.673.25.25,0,0,1-.243.308Zm1.338,2.395a.251.251,0,0,1,.187-.416H7.909a.25.25,0,0,1,.231.156,19.19,19.19,0,0,0,1.018,2.11.25.25,0,0,1-.314.353A8.428,8.428,0,0,1,5.777,15.977Zm4.6-.057a.25.25,0,0,1,.225-.359h2.806a.25.25,0,0,1,.225.359,19.41,19.41,0,0,1-1.448,2.468.219.219,0,0,1-.361,0A19.4,19.4,0,0,1,10.381,15.92Z']],
  EthernetPort: ['ethernet-port', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M24,2a2,2,0,0,0-2-2H2A2,2,0,0,0,0,2V22a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2ZM19.5,15a1,1,0,0,1-1,1H14.75a.25.25,0,0,0-.25.25V18.5a.5.5,0,0,1-.5.5H10a.5.5,0,0,1-.5-.5V16.25A.25.25,0,0,0,9.25,16H5.5a1,1,0,0,1-1-1V7a1,1,0,0,1,1-1h1a.25.25,0,0,1,.25.25V9a.75.75,0,0,0,1.5,0V6.25A.25.25,0,0,1,8.5,6h1a.25.25,0,0,1,.25.25V9a.75.75,0,0,0,1.5,0V6.25A.25.25,0,0,1,11.5,6h1a.25.25,0,0,1,.25.25V9a.75.75,0,0,0,1.5,0V6.25A.25.25,0,0,1,14.5,6h1a.25.25,0,0,1,.25.25V9a.75.75,0,0,0,1.5,0V6.25A.25.25,0,0,1,17.5,6h1a1,1,0,0,1,1,1Z']],
  MonitorUsers: ['monitor-users', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M7.962,9.058A.5.5,0,0,0,7.5,8.75h-2a.5.5,0,0,0-.5.5v2a.5.5,0,0,0,.309.462.512.512,0,0,0,.191.038.5.5,0,0,0,.354-.147l.292-.293a.252.252,0,0,1,.354,0l2.72,2.72a.75.75,0,0,0,1.06-1.061L7.561,10.25a.25.25,0,0,1,0-.354L7.854,9.6A.5.5,0,0,0,7.962,9.058Z', 'M8,6.5A3.647,3.647,0,0,0,6.625,3.578a.251.251,0,0,1-.047-.353,2,2,0,1,0-3.156,0,.251.251,0,0,1-.047.353A3.647,3.647,0,0,0,2,6.5a.5.5,0,0,0,.5.5h5A.5.5,0,0,0,8,6.5Z', 'M20.625,3.578a.251.251,0,0,1-.047-.353,2,2,0,1,0-3.156,0,.251.251,0,0,1-.047.353A3.647,3.647,0,0,0,16,6.5a.5.5,0,0,0,.5.5h5a.5.5,0,0,0,.5-.5A3.647,3.647,0,0,0,20.625,3.578Z', 'M13.72,14.03a.748.748,0,0,0,1.06,0l2.72-2.72a.252.252,0,0,1,.354,0l.292.293a.5.5,0,0,0,.354.147.512.512,0,0,0,.191-.038A.5.5,0,0,0,19,11.25v-2a.5.5,0,0,0-.5-.5h-2a.5.5,0,0,0-.354.853l.293.293a.25.25,0,0,1,0,.354L13.72,12.969A.75.75,0,0,0,13.72,14.03Z', 'M19.5,12.5a1,1,0,0,0-1,1v4.25a.25.25,0,0,1-.25.25h-13A.25.25,0,0,1,5,17.75V13.5a1,1,0,0,0-2,0V19a2,2,0,0,0,2,2h5.5a.25.25,0,0,1,.25.25v.5a.25.25,0,0,1-.25.25H8.75a1,1,0,0,0,0,2h6a1,1,0,0,0,0-2H13a.25.25,0,0,1-.25-.25v-.5A.25.25,0,0,1,13,21h5.5a2,2,0,0,0,2-2V13.5A1,1,0,0,0,19.5,12.5Z']]
};
exports["default"] = _default;